import {Box, Grid, Typography} from "@mui/material";
import {getExtensionStatusMessage, getMostRecentExtension, isClosed, wasExtendedManually} from "./RentalInfoHelpers";
import {createTheme, responsiveFontSizes} from "@mui/material/styles";
import {ThemeProvider} from "@emotion/react";
import {EligibilityCard} from "./EligibilityCard";
import moment from "moment";
import {Faq} from "./Faq";
import {useLocation, useNavigate} from "react-router-dom";
import {ROUTES} from "../../routes";
import {useEffect} from "react";

let responsiveFontSizesTheme = createTheme();
responsiveFontSizesTheme = responsiveFontSizes(responsiveFontSizesTheme);

export function RentalInfoPage() {
    const location = useLocation();
    const stateData = location.state;
    const navigate = useNavigate();
    const missingStateData = stateData === null || stateData === undefined;

    useEffect(() => {
        if (missingStateData) navigate(ROUTES.DRIVER_PORTAL)
    }, [])

    if(missingStateData) return (<></>)
    return (<RentalInfo autoExtensions={stateData.autoExtensions} rentalEvent={stateData.rentalEvent}/>)
}

export function RentalInfo({autoExtensions, rentalEvent}) {
    let lastExtension = getMostRecentExtension(autoExtensions);
    let lastExtensionStatus = getExtensionStatusMessage(lastExtension, rentalEvent);

    function getNextExtensionDate() {
        let nextExtensionDate;
        if (rentalEvent !== null && rentalEvent !== null)
            nextExtensionDate = rentalEvent.dueDate;
        else if (lastExtension != null)
            nextExtensionDate = lastExtension.newDropOffDateTime;
        else return "Not Found"
        return moment.utc(nextExtensionDate).format('MMMM D, Y');
    }

    function getName() {
        let customerName;
        if (rentalEvent !== null && rentalEvent !== null)
            customerName = rentalEvent.customerName;
        else if (lastExtension != null)
            customerName = lastExtension.reversedFullName;
        else return "Not Found"
        if (customerName === null || customerName === undefined) return '';

        let nameComponents = customerName.split(' ');
        if (nameComponents.length === 2) return nameComponents[1];
        return customerName;
    }

    function getLastExtensionDate() {
        if (lastExtension === null) return 'NA';
        const options = {month: 'numeric', day: 'numeric', year: 'numeric'};
        const date = new Date(lastExtension.insertedAt);

        // Subtract 7 hours from the date because it could have been extended at like 1 am
        date.setUTCHours(date.getUTCHours() - 7);

        return date.toLocaleDateString('en-US', options);
    }

    function renderNextExtensionDate() {
        if (isClosed(rentalEvent)) return (<></>)
        if (
            lastExtension !== null &&
            lastExtension.status !== "SUCCEEDED" &&
            !wasExtendedManually(lastExtension, rentalEvent)
        ) return (<></>)

        return (
            <>
                <Typography variant='h6' sx={{fontWeight: 'bold'}}>{getNextExtensionDate()}</Typography>
                <Typography variant='h6'>Next Extension Date</Typography>
            </>
        )
    }

    return (
        <Grid container justifyContent='center' align='center'>
            <Box sx={{maxWidth: '400px'}}>
                <Grid item xs={12}>
                    <ThemeProvider theme={responsiveFontSizesTheme}>
                        <Typography variant='h3' sx={{pb: 2}}>Rental Overview</Typography>
                        {renderNextExtensionDate()}
                    </ThemeProvider>
                </Grid>
                <Grid item xs={12} sx={{py: 3}}>
                    <EligibilityCard content={lastExtensionStatus}/>
                </Grid>
                <Grid item xs={12} align='left'>
                    <Typography variant='h5' sx={{textDecoration: 'underline'}}>Rental Details</Typography>
                    <Typography>Name: <b>{getName()}</b></Typography>
                    <Typography>Previous Auto Extension Date: <b
                        data-testid='last-extension-date'>{getLastExtensionDate()}</b></Typography>
                    <Typography>Last Auto Extension: <b
                        data-testid='last-extension-status'>{lastExtensionStatus.statusText}</b></Typography>
                </Grid>
                <Grid item xs={12} sx={{pt: 4}}>
                    <Faq/>
                </Grid>
            </Box>
        </Grid>
    )
}